import React from 'react';
import { Navigate } from 'react-router-dom';
import { useIsOrgAdmin } from '../../hooks/useIsOrgAdmin';

/** Renders children only for org admins (and global admins); others go home. */
const OrgAdminOnly: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isOrgAdmin = useIsOrgAdmin();
  if (isOrgAdmin === null) return null; // still checking
  if (!isOrgAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
};

export default OrgAdminOnly;
